import { STATUS_ATTRIBUTE, PASSENGER_ATTRIBUTE, status } from 'constants/seating';

export const setSeatAsAssigned = (seatElement, passengerId) => {
  if (seatElement) {
    seatElement.setAttribute(STATUS_ATTRIBUTE, status.ASSIGNED);
    seatElement.setAttribute(PASSENGER_ATTRIBUTE, passengerId);
  }
};

export const setSeatAsSelected = (seatElement, passengerId) => {
  if (seatElement) {
    seatElement.setAttribute(STATUS_ATTRIBUTE, status.SELECTED);
    seatElement.setAttribute(PASSENGER_ATTRIBUTE, passengerId);
  }
};

export const setSeatAsUnavailable = (seatElement) => {
  if (seatElement) {
    seatElement.setAttribute(STATUS_ATTRIBUTE, status.UNAVAILABLE);
  }
};

export const setSeatAsBlocked = (seatElement) => {
  if (seatElement) {
    seatElement.setAttribute(STATUS_ATTRIBUTE, status.BLOCKED);
  }
};

export const getSeatStatus = (seatElement) => seatElement && seatElement.getAttribute(STATUS_ATTRIBUTE);

export const getSeatNumber = (seatElement) => seatElement && seatElement.getAttribute('id').match(/^area:selectable:seat:(.*)$/)[1];

export const getSeatPassengerId = (seatElement) => seatElement && seatElement.getAttribute(PASSENGER_ATTRIBUTE);

export const setSeatAsNonEditable = (seatElement) => {
  if (seatElement) {
    seatElement.setAttribute(STATUS_ATTRIBUTE, status.NON_EDITABLE);
  }
};

export const isSeatAvailable = (seat) => !!seat.inventoryClass && seat.available && !seat.blocked && !seat.allocated;
